export default __webpack_public_path__ + "c6c0b4f5eb16954f756ea621fe34586b.svg";